function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Packer, Paragraph, TextRun, TableCell, WidthType, ImageRun, PageBreak, Bookmark } from 'docx';
import { saveAs } from 'file-saver';
export * from 'docx';
export const elsterDocxUtils = {
  createDocument(name, documenObject) {
    Packer.toBlob(documenObject).then(blob => {
      saveAs(blob, "".concat(name, ".docx"));
    });
  },
  // Helper function to create a styled text run
  createTextRun(children, styles) {
    return new TextRun(_objectSpread(_objectSpread({}, styles), {}, {
      children
    }));
  },
  // Helper function to create a styled paragraph
  createParagraph(content) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const paragraph = _objectSpread({}, options);
    if (Array.isArray(content)) {
      paragraph.children = [...content];
    } else {
      paragraph.text = content;
    }
    return new Paragraph(_objectSpread({}, paragraph));
  },
  createParagraphWithLineBreaks(content) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const paragraph = _objectSpread({}, options);
    if (typeof content === 'string') {
      const lines = content.split('\n'); // Split text by new lines
      paragraph.children = lines.map(line => new TextRun({
        text: line,
        break: 1
      }));
    } else if (Array.isArray(content)) {
      paragraph.children = [...content];
    } else {
      paragraph.text = content;
    }
    return new Paragraph(paragraph);
  },
  createTextRunInParagraph: (txt, textRunStyles, paragraphOptions) => {
    const textRun = elsterDocxUtils.createTextRun(txt, textRunStyles);
    const paragraphWithTextRun = elsterDocxUtils.createParagraph([textRun], paragraphOptions);
    return paragraphWithTextRun;
  },
  createBookmark: (text, bookmarkId, textStyle, paragraphOptions) => {
    const paragraph = _objectSpread({}, paragraphOptions);
    paragraph.children = [new Bookmark({
      id: bookmarkId,
      children: [elsterDocxUtils.createTextRun(text, textStyle)]
    })];
    return new Paragraph(_objectSpread({}, paragraph));
  },
  // Helper function to create a table cell with common styles
  createTableCell(options, width, children) {
    return new TableCell(_objectSpread(_objectSpread({}, options), {}, {
      width: {
        size: width,
        type: WidthType.DXA
      },
      children
    }));
  },
  // Helper function to create an ImageRun
  createImageRun(imageData, transformation) {
    const imageObj = {
      data: imageData,
      transformation: {
        width: transformation.width,
        height: transformation.height
      }
    };
    if (transformation.horizontalPosition) {
      imageObj.floating = {
        horizontalPosition: {
          offset: transformation.horizontalPosition.offset
        },
        verticalPosition: {
          offset: transformation.verticalPosition.offset
        }
      };
    }
    return new ImageRun(_objectSpread({}, imageObj));
  }
};
export const emptyLine = elsterDocxUtils.createParagraph(['']);
export const pageBreak = elsterDocxUtils.createParagraph([new PageBreak()]);